export default "__VITE_ASSET__DHY94ywP__"